<template>
  <div class="ui-content dashboard">
    <div class="test-name-search cp3-test-name-search cp3-1mar-search-mobile-outer">
     <div
        class="past-test-dropdown monitor-users-search cp3-monitor-users-search cp3-search-label cp3-1mar-search-mobile"
      >
        <v-text-field
          class="search-box"
          @keydown="onSearch()"
          outlined
          :label="`Name/Email ID${tab==='Student' ? '/Student Id/Roll No.':''}`"
          v-model="search"
          append-icon="mdi-magnify"
        />
      </div>
    </div>
    <div class="page-user user manage-user">
      <v-tabs
        v-model="tab"
        background-color
        class="elevation-2 cust-tab"
        :centered="centered"
        :grow="grow"
        :vertical="vertical"
        :right="right"
        :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
        :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
        :icons-and-text="icons"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab :href="'#Coordinator'">Coordinator</v-tab>
        <v-tab :href="'#Student'">Student</v-tab>
        <v-tab :href="'#Parent'">Parent</v-tab>
        <v-tab :href="'#Teacher'">Teacher</v-tab>
        <v-tab :href="'#DEO'">D.E.O</v-tab>
        <v-tabs-items :touchless="true" v-model="tab">
          <v-tab-item :value="'Coordinator'">
            <v-card class="mx-auto normal-card">
              <ManageUsersCoor
                :search="searchText"
                :updateRouteDetails="updateRouteDetails"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'Student'">
            <v-card class="mx-auto normal-card">
              <ManageUsersStudent
                :parentRef="$refs.parentRef"
                :search="searchText"
                :updateRouteDetails="updateRouteDetails"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'Parent'">
            <v-card class="mx-auto normal-card">
              <ManageUsersParents
                ref="parentRef"
                :search="searchText"
                :updateRouteDetails="updateRouteDetails"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'Teacher'">
            <v-card class="mx-auto normal-card">
              <ManageUsersTeacher
                :search="searchText"
                :updateRouteDetails="updateRouteDetails"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'DEO'">
            <v-card class="mx-auto normal-card">
              <ManageUsersDEOs
                :search="searchText"
                :updateRouteDetails="updateRouteDetails"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>
<script>
import ManageUsersParents from "@/components/coordinator/users/ManageUsers/ManageUsersParents.vue";
import ManageUsersDEOs from "@/components/coordinator/users/ManageUsers/ManageUsersDEOs.vue";
import ManageUsersTeacher from "@/components/coordinator/users/ManageUsers/ManageUsersTeacher.vue";
import ManageUsersCoor from "@/components/coordinator/users/ManageUsers/ManageUsersCoor.vue";
import ManageUsersStudent from "@/components/coordinator/users/ManageUsers/ManageUsersStudent.vue";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "ManageUsers",
  components: {
    ManageUsersParents,
    ManageUsersCoor,
    ManageUsersStudent,
    ManageUsersDEOs,
    ManageUsersTeacher,
  },
  data() {
    return {
      tab: null,
      icons: false,
      centered: false,
      grow: false,
      vertical: false,
      prevIcon: false,
      nextIcon: false,
      right: false,
      tabs: 3,
      searchText: "",
      search: "",
      parentRef: null,
    };
  },
  mounted() {
    this.defaultData();
    this.checkSessionData();
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "activateStatus":
          crd.tabDetails[crd.selectedTab].showActivated = details.data.active;
          crd.tabDetails[crd.selectedTab].page = details.data.page;
          crd.tabDetails[crd.selectedTab].batchIds = [];
          crd.tabDetails[crd.selectedTab].centerIds = [];

          break;
        case "centerIds":
          crd.tabDetails[crd.selectedTab].centerIds = details.data.centerIds;
          // crd.tabDetails[crd.selectedTab].batchIds = [];
          break;
        case "batchIds":
          crd.tabDetails[crd.selectedTab].batchIds = details.data.batchIds;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.tab = crd.selectedTab ? crd.selectedTab : "Coordinator";
      }
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);
      if (rp.params.resetPage || !crd.routeName) {
        let subTabDetails = {
          page: 1,
          showActivated: 1,
          centerIds: [],
          batchIds: [],
          orderBy: {
            field: "name",
            order: "ASC",
          },
        };
        let tabDetail = {
          Parent: subTabDetails,
          Student: subTabDetails,
          Teacher: subTabDetails,
          Coordinator: subTabDetails,
          DEO: subTabDetails,
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: this.tab,
          tabDetails: tabDetail,
          // tabDetailObjs: tabDetail
        };
        this.setRouteDetails(routeDetails);
      }
    },
    onSearch() {
      let routeName = this.$route.name;

      if (this.typetimeout) {
        clearTimeout(this.typetimeout);
      }
      this.typetimeout = setTimeout(() => {
        this.searchText = this.search;
        let updatedDetails = { searchText: this.searchText };
        updatedDetails.routeName = routeName;
        this.setRouteDetails(updatedDetails);
      }, 1500);
    },
  },
  watch: {
    tab(val, oldVal) {
      if (oldVal) {
        // only when tab is changed and not on page load
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val, searchText: "" });
        this.searchText = "";
        this.search = "";
      }
      this.addBreadCrumbChilde([
        {
          text: val,
          disabled: false,
        },
      ]);
    },
  },
};
</script>